import React, { useState } from 'react';
import { Phone } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { useToast } from '../../hooks/use-toast';

const CTASection = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      toast({
        title: "Subscribed!",
        description: "Thank you for subscribing to our newsletter.",
      });
      setEmail('');
    }
  };

  return (
    <section className="py-16 bg-yellow-500">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Can We Help?</h3>
            <div className="flex items-center gap-3 text-white">
              <Phone size={32} />
              <span className="text-3xl font-bold">(+19) 91139 97209 </span>
            </div>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-2">Newsletter Sign-up</h3>
            <p className="text-gray-800 mb-4">Latest updates and news</p>
            <form onSubmit={handleSubmit} className="flex gap-2">
              <Input
                type="email"
                placeholder="Newsletter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-white border-none"
                required
              />
              <Button type="submit" className="bg-gray-800 hover:bg-gray-900 text-white px-8">
                Subscribe
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;